import { userMetricsApi, userMetricsSlice } from 'api/user_metrics';
import { applicationCalculationsSlice } from 'api/applications-calculations';
import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { persistStore } from 'redux-persist'
import { calcApi, calcSlice } from 'api/calc'
import { deliveryRoutesApi } from 'api/delivery_routes'
import { containersApi } from 'api/containers'
import { tnvedApi, tnvedCodesSlice } from 'api/tnved'
import { geocodingApi } from 'api/geocoding'
import { authApi, authSlice } from 'api/auth'
import { informersApi } from 'api/informers'
import { deliveryTimeApi } from 'api/delivery_time'
import { palletesApi } from 'api/palletes'
import { locationsApi } from 'api/locations'
import { declarationTypesApi, declarationTypesSlice } from 'api/declaration_types'
import { certificationSchemesApi, certificationSchemesSlice } from 'api/certification_schemes'
import {documentDurationsApi, documentDurationsSlice} from 'api/document_durations'
import { localizationApi, localizationSlice } from "api/localization";
import { currenciesApi, currencySlice } from "api/currencies";
import { techRegulationsApi, techRegulationsSlice } from "api/tech_regulations";
import { documentsTypesApi, documentsTypesSlice } from "../api/document_types";
import { brokerApi, brokerSlice } from "api/broker";
import { dictionaryApi } from 'api/dictionary'
import { mediaStoragesApi } from 'api/media_storage'
import { testDriveApi } from 'api/test_drive'
import { supportApi, supportSlice } from 'api/support'
import {notificationsApi, notificationsSlice} from 'api/notifications'

import { reportsApi } from "../api/reports";
import { bitrixApi } from "api/bitrix";
import { applicationsApi } from 'api/applications';
import { applicationsManagerApi } from 'api/applications-manager';
import { applicationsSlice } from 'api/applications-state';

import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";

export const rootReducer = combineReducers({
  [userMetricsApi.reducerPath]: userMetricsApi.reducer,
  [userMetricsSlice.name]: userMetricsSlice.reducer,
  [calcApi.reducerPath]: calcApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [deliveryRoutesApi.reducerPath]: deliveryRoutesApi.reducer,
  [containersApi.reducerPath]: containersApi.reducer,
  [geocodingApi.reducerPath]: geocodingApi.reducer,
  [tnvedApi.reducerPath]: tnvedApi.reducer,
  [informersApi.reducerPath]: informersApi.reducer,
  [deliveryTimeApi.reducerPath]: deliveryTimeApi.reducer,
  [palletesApi.reducerPath]: palletesApi.reducer,
  [locationsApi.reducerPath]: locationsApi.reducer,
  [declarationTypesApi.reducerPath]: declarationTypesApi.reducer,
  [certificationSchemesApi.reducerPath]: certificationSchemesApi.reducer,
  [documentDurationsApi.reducerPath]: documentDurationsApi.reducer,
  [techRegulationsApi.reducerPath]: techRegulationsApi.reducer,
  [documentsTypesApi.reducerPath]: documentsTypesApi.reducer,
  [localizationApi.reducerPath]: localizationApi.reducer,
  [localizationSlice.name]: localizationSlice.reducer,
  [calcSlice.name]: calcSlice.reducer,
  [tnvedCodesSlice.name]: tnvedCodesSlice.reducer,
  [authSlice.name]: authSlice.reducer,
  [currenciesApi.reducerPath]: currenciesApi.reducer,
  [currencySlice.name]: currencySlice.reducer,
  [declarationTypesSlice.name]: declarationTypesSlice.reducer,
  [certificationSchemesSlice.name]: certificationSchemesSlice.reducer,
  [documentDurationsSlice.name]: documentDurationsSlice.reducer,
  [techRegulationsSlice.name]: techRegulationsSlice.reducer,
  [documentsTypesSlice.name]: documentsTypesSlice.reducer,
  [reportsApi.reducerPath]: reportsApi.reducer,
  [bitrixApi.reducerPath]: bitrixApi.reducer,
  [brokerApi.reducerPath]: brokerApi.reducer,
  [brokerSlice.name]: brokerSlice.reducer,
  [dictionaryApi.reducerPath]: dictionaryApi.reducer,
  [mediaStoragesApi.reducerPath]: mediaStoragesApi.reducer,
  [testDriveApi.reducerPath]: testDriveApi.reducer,
  [supportApi.reducerPath]: supportApi.reducer,
  [supportSlice.name]: supportSlice.reducer,
  [notificationsApi.reducerPath]: notificationsApi.reducer,
  [notificationsSlice.name]: notificationsSlice.reducer,
  [applicationsApi.reducerPath]: applicationsApi.reducer,
  [applicationsManagerApi.reducerPath]: applicationsManagerApi.reducer,
  [applicationsSlice.name]: applicationsSlice.reducer,
  [applicationCalculationsSlice.name]: applicationCalculationsSlice.reducer,
})

export const store = configureStore({
  reducer: {
    [userMetricsApi.reducerPath]: userMetricsApi.reducer,
    [userMetricsSlice.name]: userMetricsSlice.reducer,
    [calcApi.reducerPath]: calcApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [deliveryRoutesApi.reducerPath]: deliveryRoutesApi.reducer,
    [containersApi.reducerPath]: containersApi.reducer,
    [tnvedApi.reducerPath]: tnvedApi.reducer,
    [geocodingApi.reducerPath]: geocodingApi.reducer,
    [informersApi.reducerPath]: informersApi.reducer,
    [deliveryTimeApi.reducerPath]: deliveryTimeApi.reducer,
    [palletesApi.reducerPath]: palletesApi.reducer,
    [locationsApi.reducerPath]: locationsApi.reducer,
    [declarationTypesApi.reducerPath]: declarationTypesApi.reducer,
    [certificationSchemesApi.reducerPath]: certificationSchemesApi.reducer,
    [documentDurationsApi.reducerPath]: documentDurationsApi.reducer,
    [localizationApi.reducerPath]: localizationApi.reducer,
    [techRegulationsApi.reducerPath]: techRegulationsApi.reducer,
    [documentsTypesApi.reducerPath]: documentsTypesApi.reducer,
    [reportsApi.reducerPath]: reportsApi.reducer,
    [localizationSlice.name]: localizationSlice.reducer,
    [calcSlice.name]: calcSlice.reducer,
    [authSlice.name]: authSlice.reducer,
    [tnvedCodesSlice.name]: tnvedCodesSlice.reducer,
    [currenciesApi.reducerPath]: currenciesApi.reducer,
    [currencySlice.name]: currencySlice.reducer,
    [declarationTypesSlice.name]: declarationTypesSlice.reducer,
    [certificationSchemesSlice.name]: certificationSchemesSlice.reducer,
    [documentDurationsSlice.name]: documentDurationsSlice.reducer,
    [techRegulationsSlice.name]: techRegulationsSlice.reducer,
    [documentsTypesSlice.name]: documentsTypesSlice.reducer,
    [bitrixApi.reducerPath]: bitrixApi.reducer,
    [brokerApi.reducerPath]: brokerApi.reducer,
    [brokerSlice.name]: brokerSlice.reducer,
    [dictionaryApi.reducerPath]: dictionaryApi.reducer,
    [mediaStoragesApi.reducerPath]: mediaStoragesApi.reducer,
    [testDriveApi.reducerPath]: testDriveApi.reducer,
    [supportApi.reducerPath]: supportApi.reducer,
    [supportSlice.name]: supportSlice.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    [notificationsSlice.name]: notificationsSlice.reducer,
    [applicationsApi.reducerPath]: applicationsApi.reducer,
    [applicationsManagerApi.reducerPath]: applicationsManagerApi.reducer,
    [applicationsSlice.name]: applicationsSlice.reducer,
    [applicationCalculationsSlice.name]: applicationCalculationsSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }).concat(
    userMetricsApi.middleware,
    calcApi.middleware,
    authApi.middleware,
    deliveryRoutesApi.middleware,
    containersApi.middleware,
    tnvedApi.middleware,
    geocodingApi.middleware,
    informersApi.middleware,
    deliveryTimeApi.middleware,
    palletesApi.middleware,
    declarationTypesApi.middleware,
    certificationSchemesApi.middleware,
    documentDurationsApi.middleware,
    locationsApi.middleware,
    localizationApi.middleware,
    currenciesApi.middleware,
    techRegulationsApi.middleware,
    documentsTypesApi.middleware,
    reportsApi.middleware,
    bitrixApi.middleware,
    brokerApi.middleware,
    dictionaryApi.middleware,
    mediaStoragesApi.middleware,
    testDriveApi.middleware,
    supportApi.middleware,
    notificationsApi.middleware,
    applicationsApi.middleware,
    applicationsManagerApi.middleware,
  ),
})


export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// typed hooks
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
